import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 10px 0;
`;
